import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-select-tabs',
})
export default class EdSelectTabs extends Vue {
  @Prop({ type: Array, required: true }) items!: Item[];

  public selected: Item | null = null;

  @Emit('select')
  handleClick(item: { label: string; value: string }) {
    this.selected = item;
    return item;
  }

  created() {
    this.selected = this.items[0] || null;
  }

}

interface Item {
  label: string;
  value: string;
}
